import React, { useState } from 'react';
import { useQuery, gql } from '@apollo/client';
import MerchandiseItem from '../components/MerchandiseItem';
import '../styles.css'; // Ensure styles are included

const GET_MERCH_PAGE = gql`
  query GetMerchPage($input: MerchInput!) {
    getMerchPage(input: $input) {
      id
      title
      description
      items {
        id
        title
        description
        price
        attributes
        mainImage
        additionalImages
        merchandisePageId
        categoryName
      }
    }
  }
`;

const MerchandiseDetailPage = () => {
  const { loading, error, data } = useQuery(GET_MERCH_PAGE, {
    variables: { input: { id: 13 } },
  });

  const [openCategories, setOpenCategories] = useState({});

  if (loading) return <p className="loading-text">Loading...</p>;
  if (error) return <p className="error-text">Error: {error.message}</p>;

  const { title, description, items } = data.getMerchPage;

  // 🟢 Group items by category
  const groupedItems = items.reduce((acc, item) => {
    const category = item.categoryName || "Uncategorized"; // Fallback if no category
    if (!acc[category]) acc[category] = [];
    acc[category].push(item);
    return acc;
  }, {});

  // Toggle category open/close
  const toggleCategory = (category) => {
    setOpenCategories((prev) => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  return (
    <div className="page-container">
      <div className="merch-background">
        
        

        

        {Object.keys(groupedItems).map((category) => (
          <div key={category} style={{ marginBottom: '20px', borderBottom: '1px solid #ddd' }}>
            {/* Category Header */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                cursor: 'pointer',
                background: '#a23131',
                borderRadius: '5px'
              }}
              onClick={() => toggleCategory(category)}
            >
              <h2 style={{ margin: 0 }}>{category}</h2>
              <span>{openCategories[category] ? '▼' : '▶'}</span>
            </div>

            {/* Merchandise Items (Shown only if category is open) */}
            {openCategories[category] && (
              <div className="merch-grid">
                {groupedItems[category].map((item) => (
                  <MerchandiseItem key={item.id} item={item} />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MerchandiseDetailPage;

